/**
 *
 * Manage gallery (and zoom) of product images in a product page
 *
 * @author David Pocina <dpocina[at]kooomo[dot]com>
 *
 */

/**
 * @event document#zg.gallery.rendered Gallery was rendered
 * @type {object} gallery html element div.row.thumbnails
 */

/**
 * @event document#zg.product.optionSelected. Option selected
 */

/* globals handlebarsTemplates */

(
  function ($, _) {
    'use strict'

    const Gallery = (function () {
      // CONSTRUCTOR
      // -------------------------------------------------------------------------

      /**
			 *
			 * @param element
			 * @param $parent
			 * @param options
			 * @constructor
			 */
      function Gallery(element, $parent, options) {
        this._$element = $(element)
        this._$parent = $parent
        this._options = options

        this._defaultGallery = options.gallery
        this._defaultInfo = options.info
        this._currentGallery = null
        this._currentInfo = null

        this._$warning = this._$parent.find(this._options.warning)

        this._setEventHandlers()
      }

      // STATIC METHODS
      // -------------------------------------------------------------------------

      /**
			 *
			 * @param options
			 */
      Gallery.setDefaults = function (options) {
        if (options === undefined) {
          options = {}
        }

        Gallery.DEFAULTS = _.extend({}, Gallery.DEFAULTS, options)
      }

      // PUBLIC METHODS
      // -------------------------------------------------------------------------

      /**
			 *
			 * @param options
			 */
      Gallery.prototype.setOptions = function (options) {
        if (options === undefined) {
          options = {}
        }

        this._options = _.extend({}, Gallery.DEFAULTS, this._options, options)
      }

      /**
			 *
			 * @param gallery
			 * @param info
			 */
      Gallery.prototype.setDefaultGallery = function (gallery, info) {
        this._defaultGallery = gallery
        this._defaultInfo = info

        this._renderGallery()
      }

      /**
			 *
			 * @param gallery
			 * @param info
			 */
      Gallery.prototype.setCurrentGallery = function (gallery, info) {
        this._currentGallery = gallery
        this._currentInfo = info

        this._renderGallery()
      }

      // PRIVATE METHODS
      // -------------------------------------------------------------------------

      /**
			 *
			 * @private
			 */
      Gallery.prototype._displayWarning = function () {
        if (this._currentGallery) {
          this._$warning.hide()
        } else {
          this._$warning.removeClass('hidden').fadeIn()
        }
      }

      /**
			 *
			 * @method _renderGallery
			 * @fires document#zg.gallery.rendered Gallery was rendered
			 * @private
			 */
      Gallery.prototype._renderGallery = function () {
        const data = {
          info: this._currentInfo || this._defaultInfo || {}
        }

        data.gallery = this._currentGallery || this._defaultGallery || null
        const template = this._options.galleryTemplate

        this._displayWarning()

        if (data.gallery) {
          if (this._options.index && _.isNumber(this._options.index)) {
            data.gallery = data.gallery[this._options.index] ?
              [data.gallery[this._options.index]] :
              null
          } else if (this._options.limit && _.isNumber(this._options.limit)) {
            data.gallery = data.gallery.slice(0, this._options.limit)
          }

          this._$element.html('').removeClass('slick-initialized slick-slider')
          this._$parent
						.find(this._options.mainImgGalleryProd)
						.removeClass('slick-initialized slick-slider')
          this._$parent
						.find(this._options.mainImgGalleryProd)
						.html(handlebarsTemplates.render('gallery-images', data))

          this._$element.html(handlebarsTemplates.render(template, data))

          this._$parent.trigger('zg.gallery.rendered', [this._$element, data])
        }
      }

      Gallery.prototype._sliderMainImage = function () {

        $(this._options.mainImgGalleryProd).on('init', function(){
          $('.previous-arrow').append(`<div class="slick-prev">
                <i class="d-flex">
                   <svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" fill="black">
                    <path d="M31.52,44l1.65-1.65L14.81,24L33.17,5.65L31.52,4L12.34,23.18c-0.45,0.46-0.45,1.19,0,1.65L31.52,44z"/>
                  </svg>
                </i>
                <span class="visually-hidden visually-hidden-focusable"><</span>
             </div>`);
          $('.next-arrow').append(`<div class="slick-next">
                <i class="d-flex">
                  <svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" fill="black">
                    <path d="M16.48,44l-1.65-1.65L33.19,24L14.83,5.65L16.48,4l19.18,19.18c0.45,0.46,0.45,1.19,0,1.65L16.48,44z"/>
                  </svg>
                </i>
                <span class="visually-hidden visually-hidden-focusable">></span>
             </div>`);
        })

        this._$parent.find(this._options.mainImgGalleryProd).slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          arrows: true,
          dots: true,
          customPaging: function(slider, i) {
            return `<button role="tab"
                    id="tab-${i}"
                    aria-controls="navigation${i}"
                    aria-selected="${i === 0}"
                    tabindex="${i === 0 ? '0' : '-1'}"
            >${i + 1}</button>`;
          },
          fade: true,
          autoplay: false,
          autoplaySpeed: 4000,
          speed: 300,
          asNavFor: this._options.sliderThumbs === true ? this._$parent.find('[data-type="gallery-thumb"]') : null,
          prevArrow:  $('.previous-arrow'),
          nextArrow: $('.next-arrow'),
          appendDots: $('.slider-dots'),
        })
      }

      Gallery.prototype._sliderThumbs = function () {
        this._$parent.find(Gallery.SELECTOR).slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
          centerPadding: '0px',
          asNavFor: this._$parent.find(this._options.mainImgGalleryProd),
          dots: false,
          centerMode: false,
          draggable: true,
          speed: 200,
          focusOnSelect: true,
          prevArrow: `<div class="slick-prev">
                <i class="d-flex">
                   <svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" fill="black">
                    <path d="M31.52,44l1.65-1.65L14.81,24L33.17,5.65L31.52,4L12.34,23.18c-0.45,0.46-0.45,1.19,0,1.65L31.52,44z"/>
                  </svg>
                </i>
                <span class="visually-hidden visually-hidden-focusable"><</span>
             </div>`,
          nextArrow: `<div class="slick-next">
                <i class="d-flex">
                  <svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" fill="black">
                    <path d="M16.48,44l-1.65-1.65L33.19,24L14.83,5.65L16.48,4l19.18,19.18c0.45,0.46,0.45,1.19,0,1.65L16.48,44z"/>
                  </svg>
                </i>
                <span class="visually-hidden visually-hidden-focusable">></span>
             </div>`
        })
      }

      Gallery.prototype._zoomPlugin = function () {
        if (this._options.initZoom === true) {
          const lightbox = new PhotoSwipeLightbox({
            gallery: this._options.mainImgGalleryProd,
            children: 'a',
            // dynamic import is not supported in UMD version
            pswpModule: PhotoSwipe
          })
          lightbox.init()
        } else {
          $(this._options.mainImgGalleryProd + ' a').on('click', e => {
            e.preventDefault()
          })
        }
      }

      // EVENT HANDLERS
      // -------------------------------------------------------------------------

      /**
			 * @method _setEventHandlers
			 * @listen document#zg.product.optionSelected. When user select option, if the option has image, render the gallery for specific option
			 * @private
			 */
      Gallery.prototype._setEventHandlers = function () {
        // const that = this

        this._$parent.on('zg.product.optionSelected', (e, option) => {
          if (option.hasImage) {
            this.setCurrentGallery(option.gallery, option.info)
          }
        })

        this._$parent.on('zg.gallery.rendered', () => {
          if (this._options.sliderGallery === true) {
            this._sliderMainImage()
          }

          if (this._options.sliderThumbs === true) {
            this._sliderThumbs()
          }

          this._zoomPlugin()
        })

        // Workaround to fix a bug in Slick Slider when the same quickbuy product is opened twice in a row
        const myModalEl = document.getElementById('quickbuy')
        myModalEl.addEventListener('shown.bs.modal', event => {
          $(document).find(this._options.mainImgGalleryProd).slick('refresh')
          const galleryThumb = $(document).find('[data-type="gallery-thumb"]')
          if (galleryThumb.length && galleryThumb.hasClass('slick-initialized')) {
            galleryThumb.eq(0).slick('refresh')
          }
        }, { passive: true })
        myModalEl.addEventListener('shown.bs.collapse', event => {
          $(document).find(this._options.mainImgGalleryProd).slick('refresh')
        }, { passive: true })
      }

      return Gallery
    })()

    /**
		 * @param {string}  [item]    Selector of gallery elements
		 * @param {string}  [warning] Div contain warning message "Product picture may not reflect selected color"
		 * @param {string}  [galleryTemplate] Handlebars template for thumbnails
		 * @param {int}     [limit]           maximum number of elements to be created in the gallery. 0 or false means no limit
		 */
    Gallery.DEFAULTS = {
      index: null,
      limit: null,
      warning: '[data-zg-role="image-overlay"]',
      galleryTemplate: 'gallery-item',
      mainImgGalleryProd: '[data-zg-role="main-img-product"]',
      initZoom: false,
      sliderGallery: false,
      sliderThumbs: false
    }

    /**
		 * @selector data-zg-role="gallery" The plugin start for each selector in the dom when the page load
		 */
    Gallery.SELECTOR = '[data-zg-role="gallery"]'

    this.ZgGallery = Gallery

    this.zgGalleries = function (
      $parent,
      option,
      gallery,
      info,
      setDefaultGallery
    ) {
      $parent.find(Gallery.SELECTOR).each(function () {
        const $this = $(this)
        let data = $this.data('zg.gallery')
        const options = $.extend(
          {},
          Gallery.DEFAULTS,
          this.ZG_CONFIG || {},
          $this.data(),
          typeof option === 'object' && option
        )

        gallery = gallery || options.gallery || null

        if (!data || setDefaultGallery) {
          $this.data(
            'zg.gallery',
            (data = new Gallery(this, $parent, options))
          )
          data.setDefaultGallery(gallery, info)
        }
      })
    }
  }
).call(window, jQuery, _)
